import BillingMethod from 'billing/models/BillingMethod'
import { task } from 'mobx-task'
import { Subject } from 'rxjs'

/**
 * Payment Method Editor View Model base class.
 */
export abstract class PaymentMethodEditorViewModel {
  /**
   * Subject that emits when a Billing Method is created.
   *
   * @private
   */
  private readonly onPaymentMethodCreated = new Subject<BillingMethod>()

  /**
   * Emits the Billing Method when created, or
   * `null` if cancelled.
   */
  readonly onPaymentMethodCreated$ = this.onPaymentMethodCreated.asObservable()

  /**
   * Prepares the editor.
   */
  prepare = task(async () => {
    return this.onPrepare()
  })

  /**
   * Save the billing method.
   */
  save = task.resolved(async () => {
    const billingMethod = await this.onSave()
    if (!billingMethod) {
      return
    }

    this.onPaymentMethodCreated.next(billingMethod)
    return billingMethod
  })

  /**
   * Save implementation.
   *
   * @protected
   * @returns a BillingMethod when created,
   *  or `null` if not, in which case nothing will happen.
   */
  protected abstract onSave(): Promise<BillingMethod | null>

  /**
   * Prepare implementation.
   *
   * @protected
   */
  protected abstract onPrepare(): Promise<unknown>
}
